define('plugin/membership/view/MembershipEmptyView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Membership empty view
     *
     * @class MembershipEmptyView
     */
    return LayoutView.extend({

        template: '#membership_empty_view',

        serializeData: function () {
            if(this.getOption('is_id_filter')) {
                return {
                    message: 'membership_empty_view_' + this.getOption('type') + '_id_filter_message'
                };
            }

            return {
                message: 'membership_empty_view_' + this.getOption('type') + '_message'
            };
        }

    });

});
